var React = require('react');

function IconRadioUnselected (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","fill":"white"}));
}

IconRadioUnselected.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconRadioUnselected;

IconRadioUnselected.default = IconRadioUnselected;
